import React, { useState } from 'react';
import CustomModal, { MODAL_MODES } from 'shared/components/andtComponents/Modal';
import toast from 'shared/components/andtComponents/Toast';
import useUsers from 'users/new-user-management/hooks/reactQuery/useUsers';

const EnableDisableUsersModal = ({ isOpen, setIsOpen, users, isEnable, onSuccess }) => {
  const [saveClicked] = useState(false);

  const { enableDisableUsers } = useUsers();

  const onEnableDisable = async () => {
    try {
      await enableDisableUsers.mutateAsync({ usersIds: users.map((user) => user.id), enable: isEnable });
      setIsOpen(false);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      if (error.response.status === 500) {
        toast.error('Error while changing users status');
      }
    }
  };

  const actionName = isEnable ? 'enable' : 'disable';

  return (
    <CustomModal
      onClose={() => {
        setIsOpen(false);
      }}
      onCloseClick={() => {
        setIsOpen(false);
      }}
      headerMode={MODAL_MODES.SIMPLE}
      footerDisabled={saveClicked}
      onSave={onEnableDisable}
      open={isOpen}
      automationid="enable-disable-user-modal"
      saveTitle="Confirm"
      saveDisabled={false}
      title={`Bulk ${actionName}`}
    >
      You are about to {actionName} {users.length > 1 ? `${users.length} users` : 'the user'}.
    </CustomModal>
  );
};

export default EnableDisableUsersModal;
